import { gsap } from 'gsap';

export default class Dropdown {
    constructor(el, app) {
        this.el = el;
        this.app = app;
        this.html = document.documentElement;

        this.isOpen = false;

        this.toggle = this.toggle.bind(this);

        this.cacheDom();
        this.init();
    }

    /* -----------------------------------------
     * DOM
     * ----------------------------------------- */
    cacheDom() {
        this.dom = {
            html: document.documentElement,
            toggleButtons: this.el.querySelectorAll('.js-toggle-dropdown'),
        };
    }

    /* -----------------------------------------
     * Init
     * ----------------------------------------- */
    init() {
        this.dom.toggleButtons.forEach((item) => {
            item.addEventListener('click', () => {
                this.toggle(item);
            });
        });
    }

    /* -----------------------------------------
     * Actions
     * ----------------------------------------- */
    toggle(item) {
        this.isOpen ? this.close(item) : this.open(item);
        this.isOpen = !this.isOpen;
    }

    open(item) {
        const wrapper = item.closest('.js-dropdown-wrapper');
        const dropdown = wrapper.querySelector('.js-dropdown');

        gsap.to(dropdown, {
            height: 'auto',
        });

        wrapper.classList.add('is-active');
    }

    close(item) {
        const wrapper = item.closest('.js-dropdown-wrapper');
        const dropdown = wrapper.querySelector('.js-dropdown');

        gsap.to(dropdown, {
            height: 0,
        });

        wrapper.classList.remove('is-active');
    }
}
